import { objectTypes } from "@newsela/snitch";

import useCurrentArticleLevelId from "@/view/utils/useCurrentArticleLevelId";

const useEventProperties = (
  annotationId,
  actionName,
  description,
  actionPrefix,
) => {
  const levelId = useCurrentArticleLevelId();

  return {
    objectType: objectTypes.annotation,
    actionPrefix,
    actionName,
    streamProperties: {
      content_type: "Article",
      description,
      content_id: levelId,
      object_id: annotationId,
    },
  };
};

export default useEventProperties;
